var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-body",class:{
		'mobile-sides-padding': _vm.$vuetify.breakpoint.xs,
		'tablet-sides-padding': _vm.$vuetify.breakpoint.sm,
		'desktop-sides-padding': _vm.$vuetify.breakpoint.mdAndUp,
		'setup-page-width': _vm.narrow,
	}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }